/**
 * プレビュー表示用の最小の CSV パーサ (2026-09-18)。
 *
 * 取込機能の `parseCsv` は取込専用の検証を伴い、feature の index 経由で地図ライブラリまで
 * 読み込んでしまう (テスト環境で落ちる) ため、表示だけのプレビューはここで持つ。
 * RFC4180 の引用符規則に従い、引用符内の `,` と改行、`""` のエスケープを扱う。
 */
export interface CsvPreviewTable {
  headers: string[];
  rows: string[][];
}

const CR = '\r';
const LF = '\n';

export function parseCsvForPreview(text: string): CsvPreviewTable {
  const records: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      continue;
    }
    if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      row.push(field);
      field = '';
    } else if (ch === CR || ch === LF) {
      if (ch === CR && text[i + 1] === LF) i++;
      row.push(field);
      records.push(row);
      row = [];
      field = '';
    } else {
      field += ch;
    }
  }
  if (field !== '' || row.length > 0) {
    row.push(field);
    records.push(row);
  }
  const headers = records.shift() ?? [];
  return { headers, rows: records };
}
